export const pt = {
  sign_in: 'Iniciar sessão',
  email: 'Email',
  password: 'Senha',
  i_agree_to_toc: 'Eu concordo com os termos e condições.',
  terms_and_conditions: 'Termos e condições',
  privacy_policy: 'Política de privacidade',
  already_have_an_account: 'Já tem uma conta?',
  sign_up: 'Registar',
  dont_have_an_account: 'Não tem uma conta?',
  forgot_password: 'Esqueceu-se da senha?',
  email_already_in_use: 'Email já em uso',
  weak_password: 'Senha fraca',
  too_many_attempts: 'Muitas tentativas',
  invalid_email_or_password: 'Email ou senha inválidos',
  user_already_registered: 'Usuário já registrado',
  unexpected_error: 'Erro inesperado',
  audios: 'Áudios',
  name: 'Nome',
  auto: 'Automático',
  auto_detect: 'Detectar automaticamente',
  speaker_num: 'Número de falantes',
  speaker_num_reason:
    'Se você nos informar o número de falantes, forneceremos um resultado de transcrição melhor.',
  audio_language: 'Idioma do áudio',
  your_email: 'Seu email',
  email_result: 'Enviaremos um email com o resultado da transcrição.',
  provide_language:
    'Se você informar o idioma do áudio, forneceremos um resultado de transcrição melhor.',
  upload_audio: 'Enviar Áudio',
  upload_file: 'Enviar Arquivo',
  process_audio: 'Processando seu arquivo',
  process_audio_des:
    'Aguarde enquanto seu áudio está sendo transcrito. Isso pode levar alguns minutos.',
  uploading: 'Enviando',
  pending: 'Pendente',
  uploaded: 'Enviado',
  failed: 'Falha',
  status: 'Status',
  language: 'Idioma',
  speakers: 'Falantes',
  duration: 'Duração',
  done: 'Concluído',
  close: 'Fechar',
  queuing: 'Em fila',
  created_at: 'Criado em',
  records: 'Registros',
  transcribe: 'Transcrever',
  delete: 'Excluir',
  processing: 'Processando',
  from_youtube: 'Do YouTube',
  upload_files: 'Enviar arquivos',
  place_youtube_link_here: 'Insira o link do YouTube aqui',
  submit: 'Enviar',
  email_notification:
    'O tempo de conclusão depende do comprimento e da complexidade do arquivo de áudio. Geralmente, você receberá a transcrição em algumas horas. Notificaremos você por email assim que estiver pronta.',
  filters: 'Filtros',
  filter: 'Filtrar',
  replace: 'Substituir',
  share_and_export: 'Compartilhar e Exportar',
  replace_all: 'Substituir tudo',
  next: 'Próximo',
  previous: 'Anterior',
  find: 'Localizar',
  replace_with: 'Substituir por',
  x_of_x: '{current} de {total}',
  scroll_lock: 'Bloquear rolagem',
  tags: 'Tags',
  bookmark: 'Favorito',
  audio: 'Áudio',
  cancel: 'Cancelar',
  export: 'Exportar',
  export_format: 'Formato de exportação',
  copy_text: 'Copiar texto',
  monologue: 'Monólogo',
  include_timestamps: 'Incluir marcações de tempo',
  include_speaker_names: 'Incluir nomes dos falantes',
  combine_same_speaker: 'Combinar segmentos do mesmo falante',
  export_mode: 'Modo de exportação',
  no_preview: 'Sem visualização',
  copy: 'Copiar',
  copied: 'Copiado',
  unlock_pro_feature:
    'Para desbloquear esse recurso, faça upgrade para o plano de assinatura "Pro".',
  pro_features: 'Recursos Pro',
  pro_minutes: '1800 minutos / mês',
  pro_interact_with_audio: 'Interagir com o áudio',
  pro_interact_with_audio_des: 'Fazer perguntas ao seu áudio',
  pro_summary: 'Resumo de IA',
  pro_summary_des: 'Resumir o seu áudio',
  pro_priority: 'Fila de prioridade',
  pro_priority_des: 'Processar áudio com prioridade',
  pro_multi_speakers: 'Reconhecimento de múltiplos falantes',
  pro_multi_speakers_des: 'Detecta e rotula com precisão diferentes falantes',
  redirect_to_stripe:
    'Você será redirecionado para o Stripe para concluir o pagamento.',
  x_per_month: '{x} / Mês',
  x_per_year: '{x} / Ano',
  trash: 'Lixo',
  dashboard: 'Painel de controle',
  logout: 'Sair',
  are_you_sure_to_delete:
    'Tem certeza de que deseja excluir os registros selecionados?',
  restore: 'Restaurar',
  are_you_sure_to_restore:
    'Tem certeza de que deseja restaurar os registros selecionados?',
  deleted_at: 'Excluído em',
  hidden_segment: '{x} segmentos estão ocultos após {y} minutos.',
  settings: 'Configurações',
  subscription: 'Assinatura',
  default_transcription_language: 'Idioma padrão da transcrição',
  contact_us: 'Contate-nos',
  security: 'Segurança',
  about_us: 'Sobre nós',
  download_app: 'Baixar aplicativo',
  download: 'Baixar',
  app_store: 'App Store',
  play_store: 'Play Store',
  upload_voice: 'Enviar voz',
  no_audio_found: 'Nenhum áudio encontrado',
  please_input_valid_email_first: 'Por favor, insira um email válido primeiro',
  handling_audio:
    'Estamos transcrevendo seu áudio. Por favor, aguarde um momento.',
  welcome_to_leave:
    'Você pode sair desta página, pois enviaremos um email com o resultado da transcrição.',
  send_your_result: 'Enviaremos um email com o resultado da transcrição.',
  transcribe_audio_thank:
    'Obrigado por usar nosso serviço de transcrição! Estamos trabalhando duro para transcrever seu áudio e agradecemos sua paciência.',
  transcribe_audio_no_stay:
    'Sua transcrição pode demorar um pouco, mas não se preocupe, você não precisa ficar nesta página. Enviaremos os resultados por email assim que estiverem prontos.',
  date: 'Data',
  sign_up_to_access_more_functions: 'Registre-se para acessar mais funções',
  you_can_use_functions: 'Você pode usar as seguintes funções após fazer login',
  know_more: 'Saiba mais',
  modify_transcription: 'Modificar transcrição de texto',
  play_audio: 'Reproduzir áudio',
  content_filters: 'Filtros de conteúdo',
  export_diff_type: 'Exportar diferentes tipos de arquivos',
  screenshots: 'Capturas de tela',
  free_trial: 'Teste gratuito',
  pricing: 'Preços',
  faq: 'Perguntas frequentes',
  contact: 'Contato',
  login: 'Entrar',
  register: 'Registrar',
  please_login_before_purchase: 'Faça login antes de fazer a compra',
  no_records_found: 'Nenhum registro encontrado',
  x_minutes: '{x} Minutos',
  confirm: 'Confirmar',
  notification_mobile_app: 'Notificação de Aplicativo Móvel',
  notification_mobile_app_des:
    'Receba uma notificação no aplicativo móvel quando o resultado da transcrição estiver pronto',
  notification_email: 'Notificação por Email',
  notification_email_des:
    'Receba uma notificação por e-mail quando o resultado da transcrição estiver pronto',
  video: 'Video',
  or: 'Ou',
  sign_in_with_google: 'Entrar com o Google',
  sign_in_with_apple: 'Entrar com a Apple',
  login_method: 'Método de Login',
  delete_account: 'Excluir Conta',
  delete_account_confirm_3_time:
    'Pressione o botão de exclusão 3 vezes para confirmar',
  popup_blocked: 'Bloqueio de Pop-up',
  account_info: 'Informações da Conta',
  redeem: 'Resgatar',
  redeem_code: 'Resgatar código',
  summary_des1:
    'O serviço de resumo fornece um resumo do resultado da transcrição. Ele pode resumir o resultado da transcrição em algumas frases.',
  summary_des2: 'Seu antigo resumo será substituído pelo novo resumo.',
  consume_transcription_quota: 'Consumir cota de transcrição',
  summary: 'Resumo',
  query: 'Consulta',
  mins_per_query: '{x} minutos por consulta',
  information_not_found: 'Informação não encontrada',
  permission_deny: 'Permissão negada',
  please_login_to_check_the_result:
    'Por favor, faça login para verificar o resultado',
  audio_length: 'Duração do Áudio',
  delete_permanently: 'Excluir Permanentemente',
  are_you_sure_to_delete_permanently:
    'Tem certeza de que deseja excluir permanentemente?',
  payment_id: 'ID do pagamento',
  current_plan: 'Plano atual',
  plan_name: 'Nome do plano',
  expire_date: 'Data de expiração',
  subscription_method: 'Método de assinatura',
  payment_method: 'Método de pagamento',
  payment_history: 'Histórico de pagamento',
  amount: 'Quantia',
  invoice: 'Fatura',
  receipt: 'Recibo',
  link: 'Link',
  edit: 'Editar',
  back: 'Voltar',
  return: 'Retornar',
  cancel_subscription: 'Cancelar assinatura',
  cancel_subscription_google_play:
    'No seu dispositivo Android > Acesse a Google Play Store > Conta > Pagamentos e assinaturas > Assinaturas > SoundType AI > Cancelar assinatura',
  cancel_subscription_apple_store:
    'No seu dispositivo iOS > Acesse Ajustes > [seu nome] > Assinaturas > SoundType AI > Cancelar assinatura',
  delete_account_des:
    'Deletar a conta irá deletar todos os seus dados permanentemente.',
  delete_account_subscription:
    'Se você tem uma assinatura, por favor, cancele sua assinatura primeiro.',
  keep_subscription: 'Manter Assinatura',
  cancel_subscription_feature1: 'Gravações',
  cancel_subscription_feature1_des:
    'Você só poderá visualizar os primeiros {x} minutos de suas gravações.',
  cancel_subscription_feature2: 'Tempo de transcrição',
  cancel_subscription_feature2_des:
    'Você só poderá transcrever {x} minutos por mês.',
  cancel_subscription_count:
    'Por favor, pressione o botão {x} vezes para confirmar',
  next_payment_date: 'Data do próximo pagamento',
  basic_plan: 'Plano Básico',
  resume_subscription: 'Retomar assinatura',
  active: 'Ativo',
  expired: 'Expirado',
  auto_renewal_clause: 'Cláusula de renovação automática',
  auto_renewal_payment_web:
    'Sua assinatura será renovada automaticamente, a menos que você a cancele pelo menos 24 horas antes do final do período atual. Sua conta será cobrada pela renovação dentro de 24 horas antes do final do período atual. Você pode gerenciar e cancelar suas assinaturas acessando "Configurações" > "Cobrança".',
  auto_renewal_terms_and_conditions:
    'Ao assinar, você concorda com nossos Termos e Condições e Política de Privacidade.',
  payment: 'Pagamento',
  monthly: 'Mensal',
  annual: 'Anual',
  minutes_per_month: '{x} minutos/mês',
  buy_now: 'Comprar Agora',
  yearly: 'Anual',
  yearly_save: 'Economize até {x}%',
  pro_plan: 'Pro',
  business_plan: 'Negócios',
  enterprise_plan: 'Empresarial',
  everything_in_basic: 'Tudo no Básico, mais',
  everything_in_pro: 'Tudo no Pro, mais',
  everything_in_business: 'Tudo nos Negócios, mais',
  ai_chat_x: 'Chat de IA x {x}',
  ai_summary_x: 'Resumo de IA x {x}',
  max_x_minutes_per_transcription: 'Máximo de {x} minutos por transcrição',
  basic_des2: 'Identificação do falante',
  basic_des3: 'Transcrição de arquivo de áudio/vídeo',
  basic_des4: 'Revisar & editar transcrições',
  pro_des2: 'Fila Prioritária',
  pro_des3: 'Exportar no formato SRT',
  pro_des4: 'Resumo de IA ilimitado',
  business_des1: 'Relatório de análise de uso',
  business_des2: 'Espaço de trabalho colaborativo com membros da equipe',
  business_des3: 'Compartilhe e edite transcrições com sua equipe.',
  business_des4: 'Controle as permissões de compartilhamento',
  coming_soon: 'Em Breve',
  get_started: 'Começar',
  bill_annually_x: 'Faturado {x} anualmente',
  no_credit_card_required: 'Não é necessário cartão de crédito',
  save_x: 'Economize {x}%',
  price_per_month: ' / mês',
  not_available: 'Não disponível',
  pricing_title: 'Preços',
  upgrade: 'Atualizar',
  ask_question_to_your_audio: 'Faça uma pergunta ao seu áudio',
  monthly_minutes: 'Minutos mensais',
  payment_interval: 'Intervalo de pagamento',
  annually: 'Anualmente',
  billing: 'Faturamento',
  subscription_plan: 'Plano',
  please_cancel_your_current_subscription_first:
    'Por favor, cancele sua assinatura atual primeiro',
  please_cancel_your_current_subscription_first_des:
    'Para mudar seu plano de assinatura, você precisa cancelar sua assinatura atual primeiro.',
  cancel_subscription_instruction:
    'Vá para Configurações > Faturamento > Cancelar Assinatura',
  website_version: 'Versão do Site',
  change_to_annual_plan: 'Mudar para o Plano Anual',
  update_annual_mobile_platform_reminder: 'Lembrete',
  update_annual_mobile_platform_reminder_des:
    'Por favor, note que você precisa cancelar sua assinatura atual em {x} antes de mudar para o plano anual. Caso contrário, você será cobrado duas vezes.',
  i_understand: 'Eu entendo',
  no_credit: 'Minutos insuficientes',
  re_submit: 'Reenviar',
  loading_audio: 'Carregando áudio',
  your_password: 'Sua senha',
  home: 'Início',
  title_a_z: 'Título A-Z',
  title_z_a: 'Título Z-A',
  older_first: 'Mais antigo primeiro',
  newest_first: 'Mais recente primeiro',
  table_item_count: '{x} - {y} de {z} itens',
  starred: 'Estrelado',
  search: 'Pesquisar',
  create_folder: 'Criar pasta',
  folder_name: 'Nome da pasta',
  create: 'Criar',
  export_preview: 'Exportar visualização',
  combine_segments: 'Combinar segmentos',
  export_audio_only:
    'Você só pode exportar áudio quando o áudio estiver sendo transcrito.',
  transcribe_remaining_x_minutes: 'Transcrever os {x} minutos restantes',
  x_minutes_remain_be_transcribed:
    '{x} minutos restantes para serem transcritos',
  upgrade_plan_to_transcribe:
    'Atualize seu plano para transcrever o áudio completo',
  only_paid_user_can_use:
    'Somente usuários pagos podem transcrever os minutos restantes',
  converting_to_audio: 'Convertendo para áudio',
  move_to_folder: 'Mover para a pasta',
  move_audios_to_folder: 'Mover os áudios selecionados para a pasta',
  please_select_folder: 'Por favor, selecione uma pasta',
  empty_folder: 'Pasta vazia',
  move: 'Mover',
  user_not_found:
    'Usuário não encontrado. O usuário especificado não pôde ser localizado. Verifique os detalhes e tente novamente, ou entre em contato com o suporte se precisar de mais assistência.',
  invalid_link: 'Link inválido',
  translation: 'Tradução',
  translate: 'Traduzir',
  translate_des1:
    'O serviço de tradução fornece uma tradução por IA do resultado da transcrição. Ele pode traduzir o resultado da transcrição para outro idioma.',
  translate_des2: 'O texto traduzido não é editável no momento.',
  translate_des3: 'Sua tradução antiga será substituída pela nova tradução.',
  translating: 'Traduzindo',
  translating_des:
    'O processo de tradução está em andamento. Por favor, aguarde um momento. Nós o notificaremos quando a tradução estiver pronta.',
  please_select_language: 'Selecione um idioma',
  display_language: 'Idioma de exibição',
  both: 'Ambos',
  original: 'Original',
  translated: 'Traduzido',
  default_payment_currency_x_set:
    'Sua moeda de pagamento está definida como {x}. Se desejar alterá-la, entre em contato conosco em {email} .',
  invalid_link_des:
    'O link do YouTube é inválido. Vídeos ao vivo, playlists, conteúdo privado, com restrição de idade ou bloqueado por região não são suportados.',
  free_member_limited_view:
    'Os usuários do plano básico terão acesso apenas aos primeiros {x} minutos do resultado da transcrição.',
  free_user_service_once:
    'Os usuários do plano básico podem usar este serviço apenas uma vez.',
  free_user_summary:
    'Os usuários do plano básico podem usar este serviço apenas uma vez. Faça o upgrade para o plano Pro para resumir mais áudios.',
  free_user_query:
    'Os usuários do plano básico podem usar este serviço apenas uma vez. Faça o upgrade para o plano Pro para fazer mais consultas.',
  cancel_subscription_des:
    'Sua assinatura será cancelada ao final do ciclo de faturamento atual ({x}). Após essa data, você será rebaixado para o plano básico e não terá mais acesso aos recursos do plano Pro:',
  free_member_limited_transcribe_view:
    'Apenas os primeiros {x} minutos serão transcritos e visíveis para usuários do plano básico.',
  reset_password_email_sent:
    'Por favor, verifique seu e-mail. Se esta conta existir, um e-mail de redefinição de senha será enviado.',
  m_downloads: '1M+ Downloads',
  provider: 'Provedor',
  size: 'Tamanho',
  category: 'Categoria',
  productivity: 'Produtividade',
  languages: 'Idiomas',
  languages_90: '90+ idiomas',
  app_des:
    'Transforme palavras faladas em texto sem esforço com o SoundType AI! Nosso aplicativo de ponta converte gravações de voz e arquivos de áudio em transcrições baseadas em texto altamente precisas. Seja em reuniões, entrevistas, podcasts ou conteúdo de vídeo, o SoundType AI oferece precisão e eficiência.<br><br>Principais recursos:<br>- Identificação avançada de locutores: Diferencie locutores individuais com facilidade.<br>- Resumos alimentados por IA: Gere resumos concisos e informativos de suas transcrições.<br>- Suporte global de idiomas: Transcreva conversas em mais de 90 idiomas com facilidade.<br>- Recursos de áudio avançados: Projetado para profissionais, criadores e empresas.<br><br>Diga adeus às transcrições manuais demoradas e adote uma maneira mais inteligente e rápida de transformar áudio em texto com o SoundType AI.',
  click_or_drop_file: 'Clique ou arraste áudio / vídeo',
  remain_x_y_minutes: 'Restam {x}/{y} minutos',
  my_account: 'Minha conta',
  please_fill_your_email: 'Por favor, insira seu e-mail',
  please_select_language_first: 'Por favor, selecione o idioma primeiro',
  please_select_audio_first: 'Por favor, selecione o áudio primeiro',
  please_fill_youtube_link: 'Por favor, insira o link do Youtube',
  speaker_person_x: 'Orador {x}',
  sign_up_to_unlock_des:
    'Inscreva-se para editar transcrições, exportar arquivos e acessar resumos e traduções baseados em IA e muito mais. Simplifique seu fluxo de trabalho hoje mesmo!',
  your_audio_being_transcribed: 'Seu áudio está sendo transcrito...',
  sign_up_to_unlock: 'Inscreva-se para explorar mais recursos',
  try_for_free_title: 'Experimente grátis',
  try_for_free_subtitle:
    'Experimente maior potência de IA, precisão superior e recursos avançados',
  purchase_success: 'Pagamento bem-sucedido!',
  purchase_success_des:
    'Obrigado pela sua compra. Sua transação foi concluída com sucesso.',
  auto_redirect_to_dashboard:
    'Você será redirecionado para o seu painel em breve. Se o redirecionamento não ocorrer dentro de 5 segundos, clique no link a seguir para continuar manualmente:',
  need_assistance: 'Precisa de ajuda? Contate-nos em {email}',
  invalid_format: 'Formato inválido',
  top_up: 'Recarga',
  valid_x_months: 'Válido para o mês atual do plano ({x}).',
  top_up_des:
    'Os minutos recarregados são válidos apenas para o mês atual do plano. Os dados restantes não podem ser transferidos para o próximo mês.',
  basic_plan_user_cant_top_up:
    'Os usuários do plano básico não podem recarregar minutos. Atualize seu plano para habilitar as opções de recarga.',
  file_size_exceeded_gb: 'O tamanho do arquivo excede o limite de {x} GB.',
  no_speech: 'Nenhuma fala detectada na gravação.',
  credit_usages: 'Uso de Créditos',
  used_minutes: 'Minutos Utilizados',
  usage_type: 'Tipo de Uso',
  transcription: 'Transcrição',
  ai_summary: 'Resumo por IA',
  ai_chat: 'Chat com IA',
  deleted_audio: 'Áudio excluído',
  view_audio: 'Ver áudio',
  delete_audios_move_to_bin:
    'Os registros excluídos serão movidos para a lixeira.',
  bin_audio_x_days:
    'Todos os registros na lixeira serão excluídos após {x} dias.',
  total_credits: 'Créditos Totais',
  available_credits: 'Créditos Disponíveis',
  yearly_plan_credit_renew_explanation:
    'Seus créditos serão renovados todo mês no plano anual.',
  summary_period: 'Período de resumo',
}
